import { gql } from 'apollo-boost';

export const AUTHED_MEMBER = gql`
  {
    authedMember {
      id
      partnershipId
      firstName
      lastName
      email
    }
  }
`;
